<template>
	<transition-group name="fade">
		<div
			v-if="showHints && !isLocked"
			class="gesture-hint lock-hint"
			:class="{ 'hint-active': isDraggingUp }"
			key="lock-hint"
		>
			<q-icon name="lock" size="16px" />
			<span class="hint-text">{{ $t('slideToLock') }}</span>
		</div>

		<div
			v-if="showHints && !isLocked"
			class="gesture-hint cancel-hint"
			:class="{ 'hint-active': isDraggingRight }"
			key="cancel-hint"
		>
			<q-icon name="close" size="16px" />
			<span class="hint-text">{{ $t('slideToCancel') }}</span>
		</div>
	</transition-group>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'GestureHints',
	props: {
		showHints: {
			type: Boolean,
			default: false
		},
		isLocked: {
			type: Boolean,
			default: false
		},
		isDraggingUp: {
			type: Boolean,
			default: false
		},
		isDraggingRight: {
			type: Boolean,
			default: false
		}
	}
});
</script>

<style scoped lang="scss">
.gesture-hint {
	position: absolute;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 10px;
	background: rgba(255, 255, 255, 0.95);
	border-radius: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	font-size: 12px;
	font-weight: 500;
	backdrop-filter: blur(10px);
	border: 1px solid rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
	z-index: 5;
	cursor: default;

	.hint-text {
		white-space: nowrap;
	}

	.q-icon {
		transition: all 0.3s ease;
	}
}

.lock-hint {
	top: -50px;
	left: 0;
	color: #666;

	&.hint-active {
		background: #4caf50;
		color: white;
		transform: scale(1.05);
	}
}

.cancel-hint {
	left: 230px;
	top: 50%;
	transform: translateY(-50%);
	color: #666;

	&.hint-active {
		background: #ff4444;
		color: white;
		transform: translateY(-50%) scale(1.05);
	}
}

@media screen and (min-width: 767px) {
	.lock-hint {
		top: -60px;
	}

	.cancel-hint {
		left: 250px;
	}
}

@media screen and (max-width: 380px) {
	.cancel-hint {
		left: 210px;

		.hint-text {
			display: none;
		}
	}
}
</style>
